/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import sortBy from 'lodash/sortBy';
import { userGroupSelectors } from '../../../../app/resource/user-group/user-group.selectors';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { IUserGroupsProps } from './types';
import { deleteUserGroup, updateUserGroup } from '../../../../app/page/page-storage/user-groups/user-groups.actions';
import { openDialog } from '../../../../app/dialog/dialog.actions';

export const UserGroups: FunctionComponent<IUserGroupsProps> = ({ groupIds, onFocusUserGroup }) => {
  const dispatch = useDispatch();
  const groups = useSelectWithParams(userGroupSelectors.selectResourcesById, groupIds);

  const sortedGroups = sortBy(groups, ['name']);

  const [editableGroupId, setEditableGroupId] = useState<string | null>(null);
  const [isEdit, setIsEdit] = useState<boolean | null>(null);
  const [newName, setNewName] = useState<string>('');
  const inputRef = useRef<HTMLInputElement | null>(null);

  const openUserDeleteGroupForm = useCallback(
    (groupId: string) => {
      dispatch(
        openDialog('deleteDialog', {
          onConfirm: () => {
            dispatch(deleteUserGroup(groupId));
          },
        }),
      );
    },
    [dispatch],
  );

  const handleEditClick = (groupId: string) => {
    setIsEdit(!isEdit);
    setNewName(getName(groupId));
    setEditableGroupId(groupId === editableGroupId ? null : groupId);
    if (newName && newName?.length > 0 && !!isEdit && newName !== getName(groupId)) {
      dispatch(updateUserGroup(groupId, newName));
      setNewName('');
    }
  };
  const getName = (groupId: string) => {
    return groups.find((group) => group?.id === groupId)?.name ?? '';
  };

  useEffect(() => {
    if (editableGroupId !== null && inputRef.current) {
      inputRef.current.focus();
    }
  }, [editableGroupId]);

  return (
    <>
      {sortedGroups.map(
        (group) =>
          group && (
            <div
              key={group.id}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
              className="directory-button panel flex aic px-1 mb-1"
            >
              <div
                onClick={() => !isEdit && onFocusUserGroup(group.userIds)}
                key={`user-group-${group.id}`}
                style={{ cursor: `${!isEdit ? 'pointer' : 'default'}` }}
              >
                {editableGroupId && editableGroupId === group.id ? (
                  <div
                    style={{
                      border: `${newName?.length === 0 ? '1px solid red' : 'none'}`,
                      borderRadius: '2px',
                    }}
                  >
                    <input
                      type="text"
                      value={newName}
                      onChange={(e) => setNewName(e.target.value)}
                      style={{
                        border: 'none',
                        outline: 'none',
                        backgroundColor: 'none',
                        color: 'inherit',
                        width: '100%',
                        height: 'auto',
                      }}
                      ref={inputRef}
                    />
                  </div>
                ) : (
                  <>
                    <i className="icon-user-full mr-1 blueGray"></i> {group.name}
                  </>
                )}
              </div>
              <div>
                {editableGroupId && editableGroupId === group.id ? (
                  <i className="icon icon-check green blueGray ml-1" onClick={() => handleEditClick(group.id)} />
                ) : (
                  <>
                    <i
                      className="icon icon-pencil blueGray ml-1"
                      onClick={() => !isEdit && handleEditClick(group.id)}
                      style={{ cursor: `${!isEdit ? 'pointer' : 'default'}` }}
                    />
                    <i
                      className="icon2-trash blueGray ml-1"
                      onClick={() => !isEdit && openUserDeleteGroupForm(group.id)}
                      style={{ cursor: `${!isEdit ? 'pointer' : 'default'}` }}
                    />
                    <span className="ml-auto blueGray ml-1">{group.userIds ? group.userIds.length : 0}</span>
                  </>
                )}
              </div>
            </div>
          ),
      )}
    </>
  );
};
